import { Component, Injector, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NumberFormatPipe } from 'src/app/shared/pipes';
import { MatIconModule } from '@angular/material/icon';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';

@Component({
  selector: 'app-pdf-statistics-card',
  standalone: true,
  imports: [CommonModule, TranslateModule, NumberFormatPipe, MatIconModule],
  templateUrl: './pdf-statistics-card.component.html',
  styleUrls: ['./pdf-statistics-card.component.scss'],
})
export class PdfStatisticsCardComponent extends BaseComponent implements OnInit {
  @Input() percentage : number = 0;
  @Input() cardHeaderLabel : string = '';
  @Input() cardHeaderCount : number  = 0;
  @Input() totalMales : number = 0;
  @Input() totalFemales : number = 0;
  @Input() total : number = 0;


  // constants
  Math = Math;
  constructor(injector: Injector) {
    super([], injector);
  }

  ngOnInit(): void {}
}
